import AppButton from "@/components/AppButton.vue";
import HeaderRelease from "@/components/HeaderRelease.vue";
import ImageProfile from "@/components/ImageProfile.vue";
import ModalCodigo from "@/components/ModalCodigo.vue";
import TextLink from "@/components/TextLink.vue";
import Request from "@/ts/Request";
import Util from "@/ts/Util";
import HeaderColor from "orders-module/src/components/HeaderColor.vue";
import { Component, Vue } from "vue-property-decorator";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
Vue.use(Toast, {
  transition: "Vue-Toastification__bounce",
  maxToasts: 5,
  newestOnTop: true,
});

@Component({
  components: {
    TextLink,
    AppButton,
    HeaderRelease,
    ImageProfile,
    ModalCodigo,
    HeaderColor,
  },
})
export default class ContactEdit extends Vue {
  userData: any = JSON.parse(sessionStorage.getItem("USER_DATA") || "{}");

  firstName: string = this.userData.FIRST_NAME || "";

  lastName: string = this.userData.LAST_NAME || "";

  cpf: string = this.userData.CPF;

  phoneNumber: string =
    this.userData.CONTACTS && this.userData.CONTACTS[0]
      ? this.userData.CONTACTS[0].PHONE
      : "";
  otherPhone = false;
  oldPhone: string =
    this.userData.CONTACTS && this.userData.CONTACTS[0]
      ? this.userData.CONTACTS[0].PHONE
      : "";
  phoneDisabled: any = null;

  email: string =
    this.userData.CPF != "" && this.userData.CPF != null
      ? this.userData.USER_PROFILES[0].EMAIL
      : this.userData.EMAIL;

  oldEmail: string = this.userData.EMAIL;
  otherEmail = false;

  emailDisabled: any = this.userData.CPF != null ? false : true;

  showModal = false;
  modalIcon = "error_outline";
  modalMessage =
    "Ocorreu um erro desconhecido. Por favor, tente de novo mais tarde.";

  showModal3 = false;
  showBtnDeleteFile = false;
  backButton: any = {
    iconClass: "fas",
    icon: "chevron-left",
    show: true,
    callback: this.goBack,
  };

  mounted() {
    Util.setBackButtonBehavior(this.goBack);
  }

  emailChanged() {
    this.email = String($("#EMAIL").val());

    if (this.email !== this.oldEmail) {
      this.otherEmail = true;
    } else {
      this.otherEmail = false;
    }
  }

  numberPhoneChanged() {
    this.phoneNumber = String($("#CELULAR").val());

    if (this.phoneNumber !== this.oldPhone) {
      this.otherPhone = true;
    } else {
      this.otherPhone = false;
    }
  }

  changeEmail() {
    try {
      const self = this;
      const req = new Request();
      req.body = {
        USER_ID: sessionStorage.getItem("USER_ID") || "",
        TOKEN: sessionStorage.getItem("TOKEN") || "",
        EMAIL: this.email,
        NRORG: sessionStorage.getItem("NRORG"),
        OLD_PHONE: this.oldPhone,
        NEW_PHONE: this.phoneNumber,
        TOKEN_EXT: sessionStorage.getItem("TOKEN_EXT"),
      };
      req.route = "changeEmail";
      req.visibilityOptions = { success: false, error: false, loading: true };
      req.callbackSuccess = function (response: any) {
        self.userData.EMAIL = self.email;
        sessionStorage.setItem("USER_DATA", JSON.stringify(self.userData));
        sessionStorage.setItem("BIOMETRY_E", self.email);
        self.changeMobilePhoneNumber();
      };
      req.callbackError = function (error: any) {
        req.showErrorMessage(
          "Não foi possível salvar suas alterações, tente novamente."
        );
        console.log(error);
      };
      req.blockTouchEvents = false;
      req.send();
    } catch (e) {
      console.log(e);
    }
  }

  changeMobilePhoneNumber() {
    try {
      this.phoneNumber = this.phoneNumber.replace("_", "");
      const self = this;
      const req = new Request();
      req.body = {
        USER_ID: sessionStorage.getItem("USER_ID") || "",
        TOKEN: sessionStorage.getItem("TOKEN") || "",
        OLD_PHONE: this.oldPhone,
        NEW_PHONE: this.phoneNumber,
        EMAIL: this.email,
        NRORG: sessionStorage.getItem("NRORG"),
        TOKEN_EXT: sessionStorage.getItem("TOKEN_EXT"),
      };
      req.route = "changeMobilePhoneNumber";
      req.visibilityOptions = { success: false, error: false, loading: true };
      req.callbackSuccess = function (response: any) {
        self.userData.CONTACTS && self.userData.CONTACTS[0]
          ? (self.userData.CONTACTS[0].PHONE = self.phoneNumber)
          : "";
        sessionStorage.setItem("USER_DATA", JSON.stringify(self.userData));
        this.$toast.success("Dados atualizados com sucesso!");
        self.goBack();
      };
      req.callbackError = function (error: any) {
        req.showErrorMessage(
          "Não foi possível salvar suas alterações, tente novamente."
        );
        console.log(error);
      };
      req.blockTouchEvents = true;
      req.loadingMessage = "Salvando alterações...";
      req.send();
    } catch (e) {
      console.log(e);
    }
  }

  validateForm() {
    const form: HTMLFormElement = <HTMLFormElement>$("form")[0];
    return form.checkValidity();
    /* eslint-disable */
  }
  /* eslint-enable */

  focusInput(id: any) {
    const offset = -60;
    const el: any = $("#" + id);
    setTimeout(function () {
      $("html, body").animate(
        {
          scrollTop: el.offset().top + offset,
        },
        100
      );
    }, 150);
  }

  mostraModal(message: string, icon: string) {
    this.modalMessage = message;
    this.modalIcon = icon;
    this.showModal = true;
  }

  fechaModal() {
    this.goBack();
    this.showModal = false;
  }

  goBack() {
    this.$router.go(-1);
  }

  cleanInputFile() {
    const self = this;
    const control = $("#file");
    control.replaceWith(control.val(""));
    self.showBtnDeleteFile = false;
  }

  fechaModal3() {
    this.goBack();
    this.showModal3 = false;
    this.cleanInputFile();
  }

  fechaModal3_1() {
    this.showModal3 = false;
  }

  goBackCancel() {
    this.showModal3 = true;
    this.modalMessage =
      "Você tem certeza que vai cancelar? As alterações serão perdidas.";
  }
}
